export const modalOptions = (isClosable = false, backdropIndexClass = 'tw-z-40') => {
    return {
        placement: 'top-center',
        backdrop: 'static',
        backdropClasses: 'tw-bg-gray-900/50 dark:tw-bg-gray-900/80 tw-fixed tw-inset-0 ' + backdropIndexClass,
        closable: isClosable,
        onHide: () => {},
        onShow: () => {},
        onToggle: () => {},
    };
};
